import React from 'react';
import Navigation from './Navigation';
import styled from 'styled-components';

const Header = styled.header`
    width: 100%;
    min-width: 1080px;
    position: sticky;
    top: 0;
    z-index: 10;
`;

export default function () {
    return (
        <Header>
            <Navigation></Navigation>
        </Header>
    );
};